'use client';
import { Alert } from '@//components/Alert';
import { OverflowGridItem } from '@//components/OverflowGrid';
import ProductCardContainer from '@//containers/ProductCardContainer';
import ProductCardSkeleton from '@//containers/ProductCardSkeleton';
import useRelatedVehicles from '@//data/search/vehicles/useRelatedVehicles';
import { useMarketMetadata } from '@//providers/MarketSettingsProvider';

const skeletonArray = new Array(3).fill(null);

interface RelatedVehiclesResultProps {
  id: string;
}

const RelatedVehiclesResult = ({ id }: RelatedVehiclesResultProps) => {
  const relatedVehiclesQuery = useRelatedVehicles(id);
  const relatedVehicles = relatedVehiclesQuery.data;
  const marketMetadata = useMarketMetadata();

  if (relatedVehiclesQuery.isLoading)
    return (
      <>
        {skeletonArray.map((_, index) => (
          <OverflowGridItem key={index}>
            <div role="status" aria-live="polite" className="sr-only">
              Loading search results...
            </div>
            <ProductCardSkeleton key={index} />
          </OverflowGridItem>
        ))}
      </>
    );

  if (relatedVehiclesQuery.isError)
    return <Alert id="alert-error">Det gick inte att hämta annonserna...</Alert>;

  if (!relatedVehicles?.length)
    return <Alert id="alert-no-vehicles">Det finns inga annonser att visa just nu</Alert>;

  return (
    <>
      {relatedVehicles.map((vehicle, index: number) => (
        <OverflowGridItem key={vehicle._id}>
          <ProductCardContainer
            item={vehicle}
            index={index}
            itemPage={marketMetadata.pageLinks.itemPage}
            currency={marketMetadata.currency}
            testId={`related-vehicle-${index}`}
          />
        </OverflowGridItem>
      ))}
    </>
  );
};

export default RelatedVehiclesResult;
